import _regeneratorRuntime from "D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.function.name";
import _objectSpread from "D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import Breadcrumb from '@/components/Breadcrumb';
import Hamburger from '@/components/Hamburger';
import { editPassword } from '@/api/user.js';
export default {
  components: {
    Breadcrumb: Breadcrumb,
    Hamburger: Hamburger
  },
  computed: _objectSpread({}, mapGetters(['sidebar', 'name'])),
  data: function data() {
    return {
      adminName: '',
      passVisible: false,
      passForm: {
        oldPass: "",
        newPass: '',
        confirmPass: ""
      }
    };
  },
  mounted: function mounted() {
    this.init();
  },
  methods: {
    init: function init() {
      this.adminName = localStorage.getItem('name') || this.name;
    },
    //修改密码
    editPass: function editPass() {
      this.passVisible = true;
      if (this.$refs['passForm']) {
        this.$refs['passForm'].resetFields();
      }
    },
    sumbitPass: function sumbitPass(formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (_this.passForm.newPass === _this.passForm.confirmPass) {
            editPassword({
              source: _this.passForm.oldPass,
              password: _this.passForm.confirmPass
            }).then(function (res) {
              debugger;
              if (res.code == 1) {
                _this.$message({
                  message: '修改密码成功',
                  type: 'success'
                });
                _this.passVisible = false;
                _this.logout();
              } else {
                if (res.msg) {
                  _this.$message.error(res.msg);
                }
              }
            });
          } else {
            _this.$message({
              message: '新密码与确认新密码不一致，请保证一致',
              type: 'warning'
            });
          }
        } else {
          return false;
        }
      });
    },
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    logout: function () {
      var _logout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$store.dispatch('user/resetToken');
            case 2:
              this.$router.push("/login?redirect=".concat(this.$route.fullPath));
              this.$store.dispatch('tagsView/delAllViews');
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function logout() {
        return _logout.apply(this, arguments);
      }
      return logout;
    }()
  }
};